module.exports = __webpack_public_path__ + "img/2.541ba49a.jpg";